import { router } from 'expo-router';
import React, { useCallback, useState } from 'react';
import { InputAccessoryView, Platform, StyleSheet, View } from 'react-native';

import { Button, Divider, IconMail, PhoneNumberMaskInput, Text, XStack, tokens } from '@fhs/ui';
import { PHONE_INPUT_ACCESSORY_ID } from '@fhs/ui/src/components/form-text-inputs/phone-number-masked-input';

import { LegalDisclaimer } from '../components';
import { AuthIdentifiers, useAuthV2Context } from '../context';
import { checkIdentifierValidity } from '../utils';

export const SignIn = () => {
  const { createOtp } = useAuthV2Context();
  const [loginIdentifier, setLoginIdentifier] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  const onInputChange = useCallback(
    input => {
      setLoginIdentifier(input);
      setError(false);
    },
    [setLoginIdentifier, setError]
  );

  const attemptLogin = useCallback(async () => {
    if (
      checkIdentifierValidity({ loginIdentifier, identifierType: AuthIdentifiers.PHONE_NUMBER })
    ) {
      await createOtp({
        loginIdentifier,
        identifierType: AuthIdentifiers.PHONE_NUMBER,
      });
    } else {
      setError(true);
    }
  }, [createOtp, loginIdentifier]);

  return (
    <>
      <PhoneNumberMaskInput
        value={loginIdentifier}
        onChange={onInputChange}
        error={error}
        autoFocus
      />
      <LegalDisclaimer />
      {Platform.OS !== 'ios' ? (
        <View>
          <Button size="md" style={styles.continueButton} onPress={attemptLogin}>
            <Button.Text>Continue</Button.Text>
          </Button>
          <XStack style={styles.dividerContainer}>
            <Divider />
            <Text style={styles.dividerText}>or</Text>
            <Divider />
          </XStack>
          <Button
            style={styles.continueButton}
            type={'outline-subtle'}
            size="md"
            onPress={() => {
              router.push('/v2/signin/(continuewithemail)');
            }}
          >
            <Button.Icon color={tokens.colors.$blackOpacity75}>
              <IconMail />
            </Button.Icon>
            <Button.Text>Continue With Email</Button.Text>
          </Button>
        </View>
      ) : (
        <>
          <InputAccessoryView nativeID={PHONE_INPUT_ACCESSORY_ID}>
            <Button
              style={{ ...styles.continueButton, width: '85%' }}
              type={'outline-subtle'}
              size="md"
              onPress={() => {
                router.push('/v2/signin/(continuewithemail)');
              }}
            >
              <Button.Icon color={tokens.colors.$blackOpacity75}>
                <IconMail />
              </Button.Icon>
              <Button.Text>Continue With Email</Button.Text>
            </Button>
            <Button
              style={{ ...styles.continueButton, width: '85%' }}
              onPress={attemptLogin}
              size="md"
            >
              <Button.Text>Continue</Button.Text>
            </Button>
          </InputAccessoryView>
        </>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  continueButton: {
    height: 48,
    width: '100%',
    marginHorizontal: 16,
    alignSelf: 'center',
  },
  dividerText: {
    color: tokens.colors.$disabledText,
    padding: 24,
  },
  dividerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
